import { useCallback, useEffect, useState } from "react";
import AcademyAPI from "../services/academyService";

export const useAcademyProgress = ({ enabled = true } = {}) => {
    const [progress, setProgress] = useState([]);
    const [loading, setLoading] = useState(Boolean(enabled));
    const [error, setError] = useState(null);

    const loadProgress = useCallback(async () => {
        if (!enabled) {
            setLoading(false);
            setError(null);
            return;
        }
        setLoading(true);
        setError(null);

        try {
            const response = await AcademyAPI.getProgress();
            setProgress(response?.progress || []);
        } catch (err) {
            setError(err?.message || "Error cargando progreso");
            setProgress([]);
        } finally {
            setLoading(false);
        }
    }, [enabled]);

    useEffect(() => {
        loadProgress();
    }, [loadProgress]);

    return {
        progress,
        loading,
        error,
        reload: loadProgress,
    };
};
